<button
  type="button"
  class="am-bridge-fab"
  *ngIf="canUseAssetRegistry || amContext"
  (click)="togglePanel()"
  title="Asset registry"
  [class.am-pulse]="!!amContext"
>
  <span class="am-fab-icon">🏗</span>
  <span class="am-fab-count" *ngIf="amFeatureCount">{{ amFeatureCount }}</span>
  <span class="am-fab-badge" *ngIf="amModeLabel" [attr.data-mode]="amContext?.mode">{{ amModeLabel }}</span>
</button>

<aside class="am-bridge-panel" *ngIf="!amPanelCollapsed">
  <header class="am-bridge-panel__header">
    <h4>Asset registry</h4>
    <button type="button" class="am-bridge-panel__close" (click)="togglePanel()" aria-label="Close">×</button>
  </header>

  <div class="am-bridge-panel__body">
    <p class="am-bridge-panel__hint" *ngIf="amContext">
      Launched from Asset Management — {{ amContext.mode }} mode
    </p>
    <p
      class="am-bridge-panel__status"
      *ngIf="amMessage"
      [class.am-bridge-panel__status--error]="amStatus === 'error'"
    >{{ amMessage }}</p>
    <p class="am-bridge-panel__status" *ngIf="amStatus === 'loading'">Loading assets…</p>

    <label class="am-bridge-panel__field">
      <span>Layer</span>
      <select
        [ngModel]="amSelectedLayerId"
        (ngModelChange)="amOnLayerChange($event)"
      >
        <option [ngValue]="null">All layers</option>
        <option *ngFor="let layer of amLayers" [ngValue]="layer.id">
          {{ layer.name }}
        </option>
      </select>
    </label>

    <input
      type="search"
      class="am-bridge-search"
      [(ngModel)]="amSearch"
      placeholder="Search assets…"
    />

    <ul class="am-bridge-asset-list" *ngIf="amVisibleAssets.length">
      <li
        *ngFor="let asset of amFilteredAssets"
        [class.am-bridge-asset-list__item--active]="asset.id === amSelectedAssetId"
        (click)="amFocusAssetById(asset.id)"
      >
        <span class="am-bridge-asset-list__name">{{ asset.name }}</span>
        <small>{{ asset.layerName }} · {{ asset.status }}</small>
      </li>
    </ul>
    <p class="am-bridge-panel__hint" *ngIf="!amVisibleAssets.length && amStatus === 'idle'">
      No assets in this layer yet. Click an asset on the map to select it.
    </p>

    <div class="am-bridge-panel__actions">
      <button type="button" class="btn" (click)="amReloadAssets(true)">Refresh</button>
      <button type="button" class="btn" (click)="amFocusSelected()" [disabled]="!amSelectedAssetId">Focus</button>
      <button type="button" class="btn primary" (click)="amOpenSavePanel()">Save drawing</button>
      <button type="button" class="btn" (click)="amUpdateFocusedGeometry()" [disabled]="!amSelectedAssetId">
        Update geometry
      </button>
      <button type="button" class="btn danger" (click)="amDeleteSelected()" [disabled]="!amSelectedAssetId">
        Delete
      </button>
    </div>

    <div class="am-bridge-panel__save" *ngIf="amShowSavePanel">
      <label>
        <span>Name</span>
        <input type="text" [(ngModel)]="amSaveDraft.name" placeholder="Asset name" />
      </label>
      <label>
        <span>Code</span>
        <input type="text" [(ngModel)]="amSaveDraft.asset_code" placeholder="Asset code" />
      </label>
      <label>
        <span>Category</span>
        <input type="text" [(ngModel)]="amSaveDraft.asset_category" placeholder="water / ofc / electric…" />
      </label>
      <label>
        <span>Classification</span>
        <select [(ngModel)]="amSaveDraft.classification">
          <option value="overground">Overground</option>
          <option value="underground">Underground</option>
          <option value="crossover">Crossover</option>
        </select>
      </label>
      <label>
        <span>Depth (m)</span>
        <input type="number" step="0.1" [(ngModel)]="amSaveDraft.depth_m" placeholder="Burial depth" />
      </label>
      <p class="am-bridge-panel__hint" *ngIf="lrsRouteId">
        Also writes grade + depth to LRS route #{{ lrsRouteId }}
      </p>
      <label>
        <span>Status</span>
        <select [(ngModel)]="amSaveDraft.status">
          <option value="planned">Planned</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </label>
      <div class="am-bridge-panel__save-actions">
        <button type="button" class="btn primary" (click)="amSaveDrawingAsAsset()" [disabled]="amStatus === 'saving'">
          Save asset
        </button>
        <button type="button" class="btn" (click)="amCloseSavePanel()">Cancel</button>
      </div>
    </div>
  </div>
</aside>
